import { IRoute } from "@src/routes";
import UploadFilePage from "./pages/UploadFile";
import UploadFileCnpjPage from "./pages/UploadFileCnpj";
import UploadFileCleanCpfPage from "./pages/UploadFileCleanCpf";

const routes: IRoute[] = [
  {
    path: "/upload/file/:params",
    key: "UP_USER_EDIT",
    exact: true,
    component: UploadFilePage,
  },
  {
    path: "/upload/file/:params",
    key: "UP_USER_EDIT",
    exact: true,
    component: UploadFileCleanCpfPage,
  },
  {
    path: "/upload/file/:params",
    key: "UP_USER_EDIT",
    exact: true,
    component: UploadFileCnpjPage,
  },
];

export default routes;
